import apiClient from '../client';
import type { PromotionHistory, BulkPromotePayload } from '@/types';

const BASE = '/admin/promotions';

export const promotionsApi = {
  listHistory: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: PromotionHistory[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  bulkPromote: (payload: BulkPromotePayload) =>
    apiClient.post<{ data: { success: boolean; promoted_count: number } }>(`${BASE}/bulk`, payload).then((r) => r.data.data),
};

